(() => {
  if(customElements.get('guilds-clear-cart'))return;
  class GuildsClearCart extends HTMLElement{
    connectedCallback(){this.abort=new AbortController();this.querySelector('button').addEventListener('click',()=>this.clear(),{signal:this.abort.signal});}
    disconnectedCallback(){this.abort?.abort();}
    async clear(){
      const button=this.querySelector('button'),status=this.querySelector('[role="status"]');
      if(button.disabled||!window.confirm(this.dataset.confirm))return;
      button.disabled=true;const label=button.textContent;button.textContent=this.dataset.clearing;status.textContent='';
      try{
        const drawer=this.closest('cart-drawer'),sectionId=drawer?.dataset.sectionId||this.dataset.sectionId;
        const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({sections:[sectionId],sections_url:location.pathname})});
        const cart=await response.json();if(!response.ok||cart.errors||cart.item_count!==0)throw Error('clear');
        if(!drawer){location.reload();return;}
        theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate,{source:'guilds-clear',cart});
        if(!cart.sections?.[sectionId])document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{open:true}}));
      }catch{status.textContent=this.dataset.error;button.disabled=false;button.textContent=label;}
    }
  }
  customElements.define('guilds-clear-cart',GuildsClearCart);
})();

